import { render, staticRenderFns } from "./AddingPersonalLabel.vue?vue&type=template&id=2a63f677&scoped=true&"
import script from "./AddingPersonalLabel.vue?vue&type=script&lang=js&"
export * from "./AddingPersonalLabel.vue?vue&type=script&lang=js&"
import style0 from "./AddingPersonalLabel.vue?vue&type=style&index=0&id=2a63f677&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a63f677",
  null
  
)

export default component.exports